<script setup lang="ts">
import type { KjdsListPageProps, SliderItem } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const app = useNuxtApp()
const storeIndex = useStoreIndex()
const storeArticleList = useStoreArticleList()
const storeArticleSlider = useStoreArticleSlider()

const baseTitle = '特集'
const headTitle = baseTitle

const pageData = {
  tags: [] as ArticleTag[],
  items: [] as Article[],
  meta: {} as ApiMeta,
  sliderItems: [] as SliderItem[],
}

const setHead = () => {
  const headDescription = `日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］による特集ページ。展覧会やミュージアムを楽しむために役立つ情報をテーマを決めて紹介しています。美術館・博物館の情報はアイエムで！`
  const items = [
    {
      text: baseTitle,
      disabled: false,
      to: { path: '/special' },
    },
  ]
  storeIndex.setBreadCrumbs(items)

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const initPage = async () => {
  const options: KjdsFetchListOptions = { query: { ...useRoute().query } }
  const [resSite, resMaster, resList, resSlider] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName, options),
    storeArticleSlider.fetchSlider('special_slider'),
  ])
  pageData.items = resList.data.articles as Article[]
  pageData.meta = resList.meta

  const sliderArticle = resSlider.data.article as Article
  const sliderObjects = resSlider.data.article_objects as ArticleObject[]
  pageData.sliderItems = storeArticleSlider.makeSliderItems(sliderArticle, sliderObjects)

  console.log('article: initPage', pageData)
}
await initPage()
setHead()
</script>

<template>
  <div class="p-articlePage">
    <div class="l-carouselTitle">
      <SpecialSlider
        v-bind:items="pageData.sliderItems"
      />
    </div>

    <h2 class="c-heading_page p-articlePage_heading">
      特集一覧
    </h2>

    <div class="p-main_result">
      <div class="p-articlePage_list">
        <SpecialItem
          v-for="item in pageData.items"
          v-bind:key="item.id"
          v-bind:item="item"
        />
      </div>

      <Pagination
        v-bind:page="pageData.meta.page_no"
        v-bind:length="pageData.meta.total_page"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.l-carouselTitle {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;

  @include responsive.mq_down(sp) {
    position: relative;
    top: 0;
    margin-bottom: 40px;
  }
}

.p-main {
  &_result {
    position: relative;
  }
}
</style>
